import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'
import { setTruckTransIds } from '../../../store/commonSlice'
import { useDispatch } from 'react-redux'
import TruckCheckList from './truckCheckList'
import Offcanvas from 'react-bootstrap/Offcanvas'
import TruckDetails from './truckDetails'
import TruckEdit from './truckEdit'

import {
  chart,
  truck1,
  truck2,
  truck3,
  truck4,
  truck5,
  truck6,
  truck7,
} from '../../../utils/images/imagepath'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'

function TruckListView(props: any) {
  const dispatch = useDispatch()
  console.log(props)

  const [showSlider, setSlider] = useState<boolean>(false)
  const [selectedTruck, setSelectedTruck] = useState<any>([])

  const [view, setView] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [type, setType] = useState<string>('')

  const data = props?.data

  dispatch(setTruckTransIds(data))

  const handleClose = () => setSlider(false)

  const handleView = (event, data: any, type: string) => {
    event.preventDefault() // Prevent default behavior of anchor tag (e.g., navigating to a new page)
    setSlider(true)
    setType(type)
    type === 'View'
      ? (setView(true), setEdit(false))
      : (setView(false), setEdit(true))
    setSelectedTruck(data)
  }

  const truckDetails = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={truck2}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            {data.model_name} <span>{data.vin_number}</span>
          </a>
        </h2>
      </>
    )
  }

  const driverDetails = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar1}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            Cameron Jacob <span>ABC Company</span>
          </a>
        </h2>
      </>
    )
  }

  const inspectorDetails = (data: any, index: any) => {
    return <>Cameron Jacob</>
  }

  const inspectionDate = (data: any, index: any) => {
    return <>04-06-2024 10AM</>
  }

  const checkList = (data: any, index: any) => {
    const truckId = data.truck_id
    const userId = data.user_id

    return (
      <>
        <div className='data-check-list'>
          <ul className='nav'>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
            <li>
              <span className='check-list-active'></span>
            </li>
          </ul>
          <p>
            28/<span>30</span>
            {/* <a
                href='#'
                className='view-checklist'
                onClick={(e) => handleView(e, data, 'checklist')}
              >
                View Checklist
              </a> */}
            <Link to={`/truck/truck-check-list/${userId}/${truckId}`}>
              View Checklist
            </Link>
          </p>
        </div>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <span className='badge bg-light-success'>{data.status}</span>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <div className='dropdown'>
          <a
            href='javascript:void(0);'
            className='dropdown-toggle'
            data-bs-toggle='dropdown'
          >
            <i className='feather-more-vertical'></i>
          </a>
          <div className='dropdown-menu dropdown-menu-end'>
            <a
              onClick={(e) => handleView(e, data, 'View')}
              className='dropdown-item'
            >
              <i className='feather-eye'></i> View
            </a>
            <a
              onClick={(e) => handleView(e, data, 'Edit')}
              className='dropdown-item'
            >
              <i className='feather-edit'></i> Edit
            </a>
            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-trash-2'></i> Delete
            </a>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Offcanvas show={showSlider} onHide={handleClose} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{type}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {view && <TruckDetails selectedTruck={selectedTruck} />}

          {edit && <TruckEdit selectedTruck={selectedTruck} />}
          <p>This is the content of the Offcanvas.</p>
        </Offcanvas.Body>
      </Offcanvas>

      {!showSlider && (
        <DataTable
          // paginatorTemplate='CurrentPageReport  PrevPageLink PageLinks NextPageLink  '
          // currentPageReportTemplate='{first} to {last} of {totalRecords} items'
          className=''
          value={data}
          paginator
          rows={5}
          tableStyle={{ minWidth: '50rem' }}
        >
          <Column
            field='truck_details'
            header='Truck Details'
            body={truckDetails}
            sortable
          ></Column>
          <Column
            field='Licene Number'
            header='Driver Details'
            body={driverDetails}
            sortable
          ></Column>
          <Column
            field='Contact'
            header='Inspector Details'
            body={inspectorDetails}
            sortable
          ></Column>
          <Column
            field='Contact'
            header='Inspector Details'
            body={inspectionDate}
            sortable
          ></Column>
          <Column
            field='checklist'
            header='Check List'
            body={checkList}
            sortable
          ></Column>

          <Column
            field='status'
            header='Status'
            body={status}
            sortable
          ></Column>
          <Column body={action}></Column>
        </DataTable>
      )}
    </>
  )
}
export default TruckListView
